
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "IAddress": [
      "BitcoinAddress",
      "DashAddress",
      "DogecoinAddress",
      "LitecoinAddress"
    ],
    "IAddressBalanceChange": [
      "BitcoinAddressBalanceChange",
      "DashAddressBalanceChange",
      "DogecoinAddressBalanceChange",
      "LitecoinAddressBalanceChange"
    ],
    "IAddressBlock": [
      "BitcoinAddressBlock",
      "DashAddressBlock",
      "DogecoinAddressBlock",
      "LitecoinAddressBlock"
    ],
    "IAddressTransaction": [
      "BitcoinAddressTransaction",
      "DashAddressTransaction",
      "DogecoinAddressTransaction",
      "LitecoinAddressTransaction"
    ],
    "IAddressUtxo": [
      "BitcoinAddressUtxo",
      "DashAddressUtxo",
      "DogecoinAddressUtxo",
      "LitecoinAddressUtxo"
    ],
    "IBlock": [
      "BitcoinBlock",
      "DashBlock",
      "DogecoinBlock",
      "LitecoinBlock"
    ],
    "IBlockHash": [
      "BitcoinBlockHash",
      "DashBlockHash",
      "DogecoinBlockHash",
      "LitecoinBlockHash"
    ],
    "ICoin": [
      "Bitcoin",
      "Dash",
      "Dogecoin",
      "Litecoin"
    ],
    "IConfirmedTransaction": [
      "BitcoinConfirmedTransaction",
      "DashConfirmedTransaction",
      "DogecoinConfirmedTransaction",
      "LitecoinConfirmedTransaction"
    ],
    "IDate": [
      "BitcoinDate",
      "DashDate",
      "DogecoinDate",
      "LitecoinDate"
    ],
    "IMempool": [
      "BitcoinMempool",
      "DashMempool",
      "DogecoinMempool",
      "LitecoinMempool"
    ],
    "IRichList": [
      "BitcoinRichList",
      "DashRichList",
      "DogecoinRichList",
      "LitecoinRichList"
    ],
    "IScriptPubKey": [
      "BitcoinScriptPubKey",
      "DashScriptPubKey",
      "DogecoinScriptPubKey",
      "LitecoinScriptPubKey"
    ],
    "ITransaction": [
      "BitcoinTransaction",
      "DashTransaction",
      "DogecoinTransaction",
      "LitecoinTransaction"
    ],
    "ITransactionInput": [
      "BitcoinTransactionInput",
      "DashTransactionInput",
      "DogecoinTransactionInput",
      "LitecoinTransactionInput"
    ],
    "ITransactionOutput": [
      "BitcoinTransactionOutput",
      "DashTransactionOutput",
      "DogecoinTransactionOutput",
      "LitecoinTransactionOutput"
    ],
    "IUnconfirmedAddressTransaction": [
      "BitcoinUnconfirmedAddressTransaction",
      "DashUnconfirmedAddressTransaction",
      "DogecoinUnconfirmedAddressTransaction",
      "LitecoinUnconfirmedAddressTransaction"
    ],
    "IUnconfirmedTransaction": [
      "BitcoinUnconfirmedTransaction",
      "DashUnconfirmedTransaction",
      "DogecoinUnconfirmedTransaction",
      "LitecoinUnconfirmedTransaction"
    ],
    "PaginatedIAddressBalanceChangeResponse": [
      "BitcoinPaginatedAddressBalanceChangeResponse",
      "DashPaginatedAddressBalanceChangeResponse",
      "DogecoinPaginatedAddressBalanceChangeResponse",
      "LitecoinPaginatedAddressBalanceChangeResponse"
    ],
    "PaginatedIAddressBalanceResponse": [
      "BitcoinPaginatedAddressBalanceResponse",
      "DashPaginatedAddressBalanceResponse",
      "DogecoinPaginatedAddressBalanceResponse",
      "LitecoinPaginatedAddressBalanceResponse"
    ],
    "PaginatedIAddressTransactionResponse": [
      "BitcoinPaginatedAddressTransactionResponse",
      "DashPaginatedAddressTransactionResponse",
      "DogecoinPaginatedAddressTransactionResponse",
      "LitecoinPaginatedAddressTransactionResponse"
    ],
    "PaginatedIAddressUtxoResponse": [
      "BitcoinPaginatedAddressUtxoResponse",
      "DashPaginatedAddressUtxoResponse",
      "DogecoinPaginatedAddressUtxoResponse",
      "LitecoinPaginatedAddressUtxoResponse"
    ],
    "PaginatedIBlockHashResponse": [
      "BitcoinPaginatedBlockHashResponse",
      "DashPaginatedBlockHashResponse",
      "DogecoinPaginatedBlockHashResponse",
      "LitecoinPaginatedBlockHashResponse"
    ],
    "PaginatedIConfirmedTransactionResponse": [
      "BitcoinPaginatedConfirmedTransactionResponse",
      "DashPaginatedConfirmedTransactionResponse",
      "DogecoinPaginatedConfirmedTransactionResponse",
      "LitecoinPaginatedConfirmedTransactionResponse"
    ],
    "PaginatedIRichlistResponse": [
      "BitcoinPaginatedRichlistResponse",
      "DashPaginatedRichlistResponse",
      "DogecoinPaginatedRichlistResponse",
      "LitecoinPaginatedRichlistResponse"
    ],
    "PaginatedITransactionInputResponse": [
      "BitcoinPaginatedTransactionInputResponse",
      "DashPaginatedTransactionInputResponse",
      "DogecoinPaginatedTransactionInputResponse",
      "LitecoinPaginatedTransactionInputResponse"
    ],
    "PaginatedITransactionOutputResponse": [
      "BitcoinPaginatedTransactionOutputResponse",
      "DashPaginatedTransactionOutputResponse",
      "DogecoinPaginatedTransactionOutputResponse",
      "LitecoinPaginatedTransactionOutputResponse"
    ],
    "PaginatedIUnconfirmedAddressTransactionResponse": [
      "BitcoinPaginatedUnconfirmedAddressTransactionResponse",
      "DashPaginatedUnconfirmedAddressTransactionResponse",
      "DogecoinPaginatedUnconfirmedAddressTransactionResponse",
      "LitecoinPaginatedUnconfirmedAddressTransactionResponse"
    ],
    "PaginatedIUnconfirmedTransactionResponse": [
      "BitcoinPaginatedUnconfirmedTransactionResponse",
      "DashPaginatedUnconfirmedTransactionResponse",
      "DogecoinPaginatedUnconfirmedTransactionResponse",
      "LitecoinPaginatedUnconfirmedTransactionResponse"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "IAddress": [
      "BitcoinAddress",
      "DashAddress",
      "DogecoinAddress",
      "LitecoinAddress"
    ],
    "IAddressBalanceChange": [
      "BitcoinAddressBalanceChange",
      "DashAddressBalanceChange",
      "DogecoinAddressBalanceChange",
      "LitecoinAddressBalanceChange"
    ],
    "IAddressBlock": [
      "BitcoinAddressBlock",
      "DashAddressBlock",
      "DogecoinAddressBlock",
      "LitecoinAddressBlock"
    ],
    "IAddressTransaction": [
      "BitcoinAddressTransaction",
      "DashAddressTransaction",
      "DogecoinAddressTransaction",
      "LitecoinAddressTransaction"
    ],
    "IAddressUtxo": [
      "BitcoinAddressUtxo",
      "DashAddressUtxo",
      "DogecoinAddressUtxo",
      "LitecoinAddressUtxo"
    ],
    "IBlock": [
      "BitcoinBlock",
      "DashBlock",
      "DogecoinBlock",
      "LitecoinBlock"
    ],
    "IBlockHash": [
      "BitcoinBlockHash",
      "DashBlockHash",
      "DogecoinBlockHash",
      "LitecoinBlockHash"
    ],
    "ICoin": [
      "Bitcoin",
      "Dash",
      "Dogecoin",
      "Litecoin"
    ],
    "IConfirmedTransaction": [
      "BitcoinConfirmedTransaction",
      "DashConfirmedTransaction",
      "DogecoinConfirmedTransaction",
      "LitecoinConfirmedTransaction"
    ],
    "IDate": [
      "BitcoinDate",
      "DashDate",
      "DogecoinDate",
      "LitecoinDate"
    ],
    "IMempool": [
      "BitcoinMempool",
      "DashMempool",
      "DogecoinMempool",
      "LitecoinMempool"
    ],
    "IRichList": [
      "BitcoinRichList",
      "DashRichList",
      "DogecoinRichList",
      "LitecoinRichList"
    ],
    "IScriptPubKey": [
      "BitcoinScriptPubKey",
      "DashScriptPubKey",
      "DogecoinScriptPubKey",
      "LitecoinScriptPubKey"
    ],
    "ITransaction": [
      "BitcoinTransaction",
      "DashTransaction",
      "DogecoinTransaction",
      "LitecoinTransaction"
    ],
    "ITransactionInput": [
      "BitcoinTransactionInput",
      "DashTransactionInput",
      "DogecoinTransactionInput",
      "LitecoinTransactionInput"
    ],
    "ITransactionOutput": [
      "BitcoinTransactionOutput",
      "DashTransactionOutput",
      "DogecoinTransactionOutput",
      "LitecoinTransactionOutput"
    ],
    "IUnconfirmedAddressTransaction": [
      "BitcoinUnconfirmedAddressTransaction",
      "DashUnconfirmedAddressTransaction",
      "DogecoinUnconfirmedAddressTransaction",
      "LitecoinUnconfirmedAddressTransaction"
    ],
    "IUnconfirmedTransaction": [
      "BitcoinUnconfirmedTransaction",
      "DashUnconfirmedTransaction",
      "DogecoinUnconfirmedTransaction",
      "LitecoinUnconfirmedTransaction"
    ],
    "PaginatedIAddressBalanceChangeResponse": [
      "BitcoinPaginatedAddressBalanceChangeResponse",
      "DashPaginatedAddressBalanceChangeResponse",
      "DogecoinPaginatedAddressBalanceChangeResponse",
      "LitecoinPaginatedAddressBalanceChangeResponse"
    ],
    "PaginatedIAddressBalanceResponse": [
      "BitcoinPaginatedAddressBalanceResponse",
      "DashPaginatedAddressBalanceResponse",
      "DogecoinPaginatedAddressBalanceResponse",
      "LitecoinPaginatedAddressBalanceResponse"
    ],
    "PaginatedIAddressTransactionResponse": [
      "BitcoinPaginatedAddressTransactionResponse",
      "DashPaginatedAddressTransactionResponse",
      "DogecoinPaginatedAddressTransactionResponse",
      "LitecoinPaginatedAddressTransactionResponse"
    ],
    "PaginatedIAddressUtxoResponse": [
      "BitcoinPaginatedAddressUtxoResponse",
      "DashPaginatedAddressUtxoResponse",
      "DogecoinPaginatedAddressUtxoResponse",
      "LitecoinPaginatedAddressUtxoResponse"
    ],
    "PaginatedIBlockHashResponse": [
      "BitcoinPaginatedBlockHashResponse",
      "DashPaginatedBlockHashResponse",
      "DogecoinPaginatedBlockHashResponse",
      "LitecoinPaginatedBlockHashResponse"
    ],
    "PaginatedIConfirmedTransactionResponse": [
      "BitcoinPaginatedConfirmedTransactionResponse",
      "DashPaginatedConfirmedTransactionResponse",
      "DogecoinPaginatedConfirmedTransactionResponse",
      "LitecoinPaginatedConfirmedTransactionResponse"
    ],
    "PaginatedIRichlistResponse": [
      "BitcoinPaginatedRichlistResponse",
      "DashPaginatedRichlistResponse",
      "DogecoinPaginatedRichlistResponse",
      "LitecoinPaginatedRichlistResponse"
    ],
    "PaginatedITransactionInputResponse": [
      "BitcoinPaginatedTransactionInputResponse",
      "DashPaginatedTransactionInputResponse",
      "DogecoinPaginatedTransactionInputResponse",
      "LitecoinPaginatedTransactionInputResponse"
    ],
    "PaginatedITransactionOutputResponse": [
      "BitcoinPaginatedTransactionOutputResponse",
      "DashPaginatedTransactionOutputResponse",
      "DogecoinPaginatedTransactionOutputResponse",
      "LitecoinPaginatedTransactionOutputResponse"
    ],
    "PaginatedIUnconfirmedAddressTransactionResponse": [
      "BitcoinPaginatedUnconfirmedAddressTransactionResponse",
      "DashPaginatedUnconfirmedAddressTransactionResponse",
      "DogecoinPaginatedUnconfirmedAddressTransactionResponse",
      "LitecoinPaginatedUnconfirmedAddressTransactionResponse"
    ],
    "PaginatedIUnconfirmedTransactionResponse": [
      "BitcoinPaginatedUnconfirmedTransactionResponse",
      "DashPaginatedUnconfirmedTransactionResponse",
      "DogecoinPaginatedUnconfirmedTransactionResponse",
      "LitecoinPaginatedUnconfirmedTransactionResponse"
    ]
  }
};
      export default result;
    